import script from "./DateSigned.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateSigned.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./DateSigned.vue3.vue?vue&type=style&index=0&id=3b9ece0c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b9ece0c"]])

export default __exports__